import React, { useEffect, useRef, useState } from 'react';
import { Group, Shape, Transformer } from 'react-konva/lib/ReactKonvaCore';
import { CANVAS_TOOL, CIRCLE, RECTANGLE, TRIANGLE } from '../constants';

export default function FigureCanvas({
    line, drawId, uuid, currentTool, canvasStyle, selected, canvasX, canvasY, scale, isWhiteBoard,
    setLine, handlerDeleteLine, handlerSelectedLine
}) {
    const trRef = useRef();
    const shapeRef = useRef();

    const [ points, setPoints ] = useState();
    const [ figure, setFigure ] = useState(null);
    const [ canvasTool, setCanvasTool ] = useState(null);
    const [ option, setOption ] = useState({}); 
    const [ ratio, setRatio ] = useState(1);

    useEffect(() => {
        if (line) {
            setCanvasTool(line.canvasTool);
            setPoints(line.points);
        } else {
            setFigure(null);
            setPoints(null);
        }
    }, [line]);

    useEffect(() => {
        if (canvasTool) {
            const ratio = canvasStyle.width / canvasTool.width || 1;
            const lineThickness = Number(canvasTool.thickness / window.devicePixelRatio);
            const figure = canvasTool.figure;

            setRatio(ratio);
            setFigure(figure);

            const isFill = figure.indexOf('fill') !== -1 ? true : false;
            let width = Math.abs(Math.floor(canvasTool.figureWidth));
            width = isNaN(width) ? 1 : width;

            let height = Math.abs(Math.floor(canvasTool.figureHeight));
            height = isNaN(height) ? 1 : height;
            
            const option = {
                fill: isFill ? canvasTool.color : "",
                stroke: canvasTool.color,
                strokeWidth: lineThickness,
                hitStrokeWidth: lineThickness,
                opacity: canvasTool.opacity,
                rotation: canvasTool.rotation,
                x: points[0], y: points[1] 
            };

            if (figure.indexOf(CIRCLE) !== -1) {
                setOption({ ...option, width, height });
            } else if (figure.indexOf(TRIANGLE) !== -1) {
                setOption({ ...option, width, height, sides: 3 });
            } else {
                setOption({ ...option, width, height, sides: 4 })
            }
        }
    }, [canvasStyle, canvasTool]);


    function getPointerPosition() {
        const pos = shapeRef.current.position();
        
        const x = (pos.x  - canvasX) / scale;
        const y = (pos.y  - canvasY) / scale;
        return { x, y };
    }

    const focusOnFigure = () => {
        if (currentTool.tool === CANVAS_TOOL.choice) handlerSelectedLine(uuid);
    }

    const handlerSetPoints = e => {
        const { x, y } = getPointerPosition();
        const newLine = { ...line, points: [x, y] };
        setLine(newLine);

        APP.mateManagement.sendPointer(uuid, newLine, isWhiteBoard, focusUuid, focusIndex);
    }

    const handlerTransform = e => {    
        // const rotation = e.target.rotation();
        const node = shapeRef.current;
        const { x, y } = getPointerPosition();
        
        const scaleX = node.scaleX();
        const scaleY = node.scaleY();

        node.scaleX(1);
        node.scaleY(1);
        
        const figureWidth = Math.max(5, node.width() * scaleX);
        const figureHeight = Math.max(5, node.height() * scaleY);

        const newLine = { ...line, points: [x, y], canvasTool: { ...line.canvasTool, figureWidth, figureHeight } };
        setLine(newLine);

        APP.mateManagement.sendPointer(uuid, newLine, isWhiteBoard, focusUuid, focusIndex);
    }

    const onDeleteLine = () => {
        if (handlerDeleteLine) handlerDeleteLine(uuid);
    }

    useEffect(() => {
        if (drawId === uuid && selected) {
            trRef.current.nodes([shapeRef.current]);
            trRef.current.getLayer().batchDraw();
        }
    }, [drawId]);

    return (
        <>
            <Group scaleX={ratio} scaleY={ratio}>
                <Shape ref={shapeRef}
                    {...option} 
                    draggable={selected} 
                    onClick={focusOnFigure} onTap={focusOnFigure}
                    onDragMove={handlerSetPoints}
                    onTransform={handlerTransform}
                        
                    onMouseOver={onDeleteLine}
                    onTouchMove={onDeleteLine}
                    transformsEnabled={'position'}
                    sceneFunc={(context, shape) => {
                        if (!canvasTool || !figure) return;
                        context.fillStyle = option.color;
                        context.strokeStyle = option.color;
                        context.lineWidth = option.strokeWidth;
                        context.lineCap = "round";

                        context.beginPath();

                        let height = option.height;
                        let width = option.width;

                        if (figure.indexOf(TRIANGLE) !== -1) {                                
                            context.moveTo(width / 2, 0);
                            context.lineTo(width, height);
                            context.lineTo(0, height);
                        } else if (figure.indexOf(CIRCLE) !== -1) {
                            if (width !== height) {
                                context.ellipse(width /2, height /2, width /2, height/2, 0, 0, 2 * Math.PI);
                            } else {
                                context.arc(width /2, height /2, width / 2);
                            }
                            
                        } else if (figure.indexOf(RECTANGLE) !== -1) {
                            context.rect(0, 0, width, height);
                        } 
                        
                        if (option.fill) context.fill();
                        else context.stroke();
                        
                        context.closePath();
                        context.fillStrokeShape(shape);
                    }}
                /> 
                
                <Transformer ref={trRef} 
                    keepRatio={false}
                    rotateEnabled={false}
                    centeredScaling={false}
                    enabledAnchors={['top-left', 'top-center', 'top-right', 'middle-right', 'middle-left', 'bottom-left', 'bottom-center', 'bottom-right']}
                    boundBoxFunc={(oldBox, newBox) => {
                        if (newBox.width < 5 || newBox.height < 5) {
                            return oldBox;
                        }
                            
                        return newBox;
                    }}
                /> 
            </Group>

            
        </>
    )
}

// centeredScaling={true}
// rotationSnaps={[0, 90, 180, 270]}
// resizeEnabled={false}